import environment from '@root/core/src/utils/environment';
import { isEmailAddressLink, isPhoneNumberLink } from '@root/joinroot.com/src/utils/detect-link-type';

const urlMap = {
  '^https?://(www.)?joinroot.com$': '/',
  '^https?://(www.)?joinroot.com/': '/',
  '^https?://account.joinroot.com': environment.accountAppBaseUrl,
  '^https?://agents.joinroot.com': environment.agentsAppBaseUrl,
  '^https?://claims.joinroot.com': environment.claimsAppBaseUrl,
  '^https?://inc.joinroot.com': environment.incSiteBaseUrl,
  '^https?://quote.joinroot.com': environment.quoteAppBaseUrl,
  '^https?://renters.joinroot.com': environment.rentersAppBaseUrl,
};

export default function environmentalizeUrl(urlToEnvironmentalize) {
  if (isPhoneNumberLink(urlToEnvironmentalize) || isEmailAddressLink(urlToEnvironmentalize)) { return urlToEnvironmentalize; }

  const updatedUrl = Object.keys(urlMap).reduce((url, urlPattern) => {
    return url.replace(new RegExp(urlPattern), urlMap[urlPattern]);
  }, urlToEnvironmentalize);

  // this will append a trailing slash if it is missing - see the tests
  return updatedUrl.replace(/^(.*?)(\/)?(\/.*\..*|\?.*|#.*)?$$/, '$1/$3').replace(/^\/\//, '/');
}
